import {
    LoanApplicationBackofficeAPIApiGetReassignmentsForBackofficeRequest,
    ReassignmentDto,
} from 'src/generated-api-client';
import { loanApplicationsApi } from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter, SorterDirection } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

type LoanApplicationReassignmentsFilter =
    ListFilter<LoanApplicationBackofficeAPIApiGetReassignmentsForBackofficeRequest>;

export class LoanApplicationReassignmentsStoreClass extends BasicStore<
    ReassignmentDto,
    LoanApplicationReassignmentsFilter,
    unknown,
    unknown,
    unknown
> {
    pager = new Pager();
    sorter = new Sorter<ReassignmentDto>([
        'reassignedAt',
        SorterDirection.DESC,
    ]);

    filterCriteria = new FilterCriteria<LoanApplicationReassignmentsFilter>();

    api: BasicStoreApi<ReassignmentDto, unknown, unknown, unknown> = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                loanApplicationsApi.getReassignmentsForBackoffice(
                    {
                        ...this.filterCriteria.filter,
                        page: this.pager.page,
                        size: this.pager.size,
                        sort: this.sorter.sort,
                    },
                    options,
                ),
            );
            this.pager?.setTotal(response.totalElements ?? 0);

            return response.content ?? [];
        },
    };
}

// Shared singleton instance of LoanApplicationReassignments store
export const LoanApplicationReassignmentsStore =
    new LoanApplicationReassignmentsStoreClass();
